import React, { useState } from "react";
import FormInput from "../components/FormInput";
import Button from "../components/Button";

import { useToast } from "../context/ToastContext";
import { useRecoveryCooldown } from "../utils/recoveryCooldown";

const Recovery = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState("");
  const { toast } = useToast();

  const { countdown, startCooldown, isCoolingDown } = useRecoveryCooldown(email);

  const handleRecuperar = async (e) => {
    e.preventDefault();

    if (loading || isCoolingDown) return;

    setError("");

    const trimmedEmail = email.trim();
    if (!trimmedEmail || !trimmedEmail.includes("@")) {
      const msg = "Por favor, informe um endereço de e-mail válido.";
      setError(msg);
      toast.error(msg);
      return;
    }

    setLoading(true);

    try {
      const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:8080/api/v1";
      const response = await fetch(
        `${apiUrl.replace(/\/+$/, "")}/passwordRecovery`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ usr_email: trimmedEmail }),
        }
      );

      const res = await response.json();

      if (response.status === 200 && res.status === "success") {
        setError("");
        setIsSent(true);
        startCooldown(60, trimmedEmail);
        toast.success(
          "Um e-mail foi enviado para você com as instruções para recuperar sua senha."
        );
      } else if (response.status === 429) {
        const msg = res?.message || "Aguarde antes de tentar novamente.";
        setError(msg);
        startCooldown(60, trimmedEmail);
        toast.error(msg);
      } else {
        const msg = res?.message || "Não conseguimos encontrar um usuário com esse endereço de e-mail.";
        setError(msg);
        toast.error(msg);
      }
    } catch (err) {
      console.error("Erro ao recuperar senha:", err);
      const msg = "Erro ao recuperar senha. Por favor, tente novamente mais tarde.";
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="recovery-form-wrapper">
      <h2 className="mb-4">
        <strong>Recuperar senha</strong>
      </h2>

      {isSent ? (
        <div
          className="alert alert-success text-center py-3 px-4 mb-4"
          role="alert"
        >
          <h6 className="fw-bold mb-2">E-mail de recuperação enviado!</h6>
          <p className="mb-2" style={{ fontSize: "14px" }}>
            Enviamos o link de redefinição para <strong>{email}</strong>.
          </p>
          <p className="mb-0 text-muted" style={{ fontSize: "13px" }}>
            O recebimento pode levar até 1 minuto. Não esqueça de verificar a caixa de spam antes de solicitar novamente.
          </p>
        </div>
      ) : (
        <p>
          Por favor, indique o seu endereço de e-mail. <br />
          Você receberá um link para criar uma nova senha por e-mail.
        </p>
      )}

      <div className="mt-4">
        <form onSubmit={handleRecuperar}>
          <FormInput
            float
            type="email"
            name="email"
            label="E-mail"
            placeholder="Informe seu e-mail"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (error) setError("");
            }}
            disabled={loading}
          />

          {error && (
            <div
              className="alert alert-danger text-center mt-3 mb-0"
              role="alert"
              style={{ fontSize: "14px", padding: "10px" }}
            >
              {error}
            </div>
          )}

          <Button
            classes="mt-4"
            type="submit"
            label={
              loading
                ? "Enviando..."
                : isCoolingDown
                ? `Aguarde ${countdown}s para reenviar`
                : isSent
                ? "Reenviar e-mail"
                : "Enviar senha"
            }
            disabled={loading || isCoolingDown}
          />
        </form>
      </div>
    </div>
  );
};

export default Recovery;
